class AWProductForm {
    constructor(container, isStickyAddToCart = false) {
        this.isStickyAddToCart = isStickyAddToCart;
        this.container = container;
        this.defaultVariantId = container.dataset.variantId || null;
        this.addToCartButton = this.container.querySelector('[data-aw-add-to-cart-button]');
        this.selects = this.container.querySelectorAll('[data-aw-select]');
        this.image = this.container.querySelector('[data-aw-variant-image]');
        this.price = this.container.querySelector('[data-aw-price]');
        this.compareAtPrice = this.container.querySelector('[data-aw-compare-at-price]');
        this.options = this.container.querySelectorAll('[data-aw-option]');
        this.addToCartButtonTemplate = this.container.querySelector('[data-aw-add-to-cart-button-content-template]');
        this.isSoldOut = this.container.dataset.isSoldOut === 'true';

        if (!this.defaultVariantId) {
            this.variantsData = JSON.parse(this.container.querySelector('[data-aw-product-variants]').textContent);
        }

        this.optionIsChangeable = Array.from(this.selects).map((select) => select.dataset.isChangeable === 'true');

        this.updateAvailableOptions();

        this.selects.forEach((select) => { 
            select.addEventListener('change', () => {
                this.selectChangeHandler();
            });
        });

        this.addToCartButton.addEventListener('click', () => {
            if (this.isSoldOut) {
                this.notifyMeButtonClickHandler();
            } else {
                this.addToCartButtonClickHandler();
            }
        });

        if (this.isStickyAddToCart) {
            window.addEventListener('aw-main-add-to-cart:update', (event) => {
                const { variant } = event.detail;
                const options = variant.options;
                this.setSelectedOptions(options);
                this.selectChangeHandler(true);
            });
        }

        this.container.querySelectorAll('label').forEach((wrapper) => {
            const select = wrapper.querySelector('[data-aw-select]');

            if (!select) return;

            wrapper.addEventListener('click', (event) => {
                if (event.target === select) return;

                event.preventDefault();

                if (typeof select.showPicker === 'function') {
                    select.showPicker();
                } else {
                    select.focus();
                    select.click();
                }
            });
        });
    }

    loading(loading) {
        const buttonLoader = this.addToCartButton?.querySelector('[data-aw-add-to-cart-loader]');
        const buttonText = this.addToCartButton?.querySelector('[data-aw-add-to-cart-button-text]');
        if (loading) {
            buttonLoader.classList.remove('tw:hidden');
            buttonText.classList.add('tw:hidden');
        } else {
            buttonLoader.classList.add('tw:hidden');
            buttonText.classList.remove('tw:hidden');
        }
    }

    addToCartButtonClickHandler() {
        this.loading(true);
        this.addToCartButton.disabled = true;
        const formData = new FormData();

        formData.append("id", this.defaultVariantId || this.getSelectedVariant().id);
        formData.append("quantity", 1);
        formData.append("sections", "cart-drawer");
        formData.append("sections_url", window.location.pathname);

        fetch(window.FoxThemeSettings.routes.cart_add_url, {
            method: "POST",
            headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
            body: formData,
        }).then((response) => response.json()).then((data) => {
            if (data.status) {
                console.error("Cart error:", data);
                return;
            }

            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, data);

            document.dispatchEvent(new CustomEvent("product-ajax:added", { detail: { product: data } }));
        }).catch((error) => { console.error("Error adding to cart:", error); })
        .finally(() => {
            this.loading(false);
            this.addToCartButton.disabled = false;
        });
    }

    notifyMeButtonClickHandler() {
        const selectedVariant = this.getSelectedVariant();

        const productData = {
            id: this.container.dataset.productId,
            title: this.container.dataset.productTitle,
            handle: this.container.dataset.productHandle,
            variants:
                this.variantsData.map(({id, title, available}) => ({ id, title, available }))
                || [{ id: this.defaultVariantId, available: !this.isSoldOut }],
        };

        window._RestockRocket.openModal(productData, selectedVariant.id || this.defaultVariantId);

    }

    selectChangeHandler(fromEvent = false) {
        this.updateAvailableOptions();
        const selectedVariant = this.getSelectedVariant();

        if (selectedVariant) {
            this.image.src = selectedVariant.image;
            this.price.textContent = selectedVariant.price;

            if (this.compareAtPrice) {
                if (selectedVariant.compareAtPrice && selectedVariant.compareAtPrice > selectedVariant.price) {
                    this.compareAtPrice.textContent = selectedVariant.compareAtPrice;
                    this.compareAtPrice.style.display = '';
                    this.price.classList.add('tw:text-[#B0573B]');
                } else {
                    this.compareAtPrice.style.display = 'none';
                    this.price.classList.remove('tw:text-[#B0573B]');
                }
            }

            this.options.forEach((option, index) => {
                option.textContent = selectedVariant.options[index];
            });

            if (selectedVariant.available) {
                this.addToCartButton.innerHTML = this.addToCartButtonTemplate.innerHTML;
                if (!this.isStickyAddToCart) {
                    this.addToCartButton.disabled = false;
                    this.addToCartButton.classList.remove('tw:opacity-50', 'tw:pointer-events-none');
                } else {
                    this.isSoldOut = false;                    
                }
            } else {
                if (!this.isStickyAddToCart) {
                    this.addToCartButton.disabled = true;
                    this.addToCartButton.innerHTML = 'Sold Out';
                    this.addToCartButton.classList.add('tw:opacity-50', 'tw:pointer-events-none');
                } else {
                    this.addToCartButton.innerHTML = 'Notify Me';
                    this.isSoldOut = true;
                }
            }

            if (this.isStickyAddToCart && !fromEvent) {
                window.dispatchEvent(new CustomEvent('aw-sticky-add-to-cart:update', { detail: { variant: selectedVariant } }));
            }
        } else {
            this.addToCartButton.disabled = true;
            this.addToCartButton.innerHTML = 'Unavailable';
            this.addToCartButton.classList.add('tw:opacity-50', 'tw:pointer-events-none');
        }
    }

    getSelectedOptions() {
        return Array.from(this.selects).map((select) => select.value);
    }

    setSelectedOptions(options) {
        this.selects.forEach((select, index) => {
            select.value = options[index];
        });
    }

    updateAvailableOptions() {
        const selectedOptions = this.getSelectedOptions();

        this.selects.forEach((select, selectIndex) => {
            Array.from(select.options).forEach((option) => {
                const testOptions = [...selectedOptions];
                testOptions[selectIndex] = option.value;

                const exists = this.variantsData.some((variant) => {
                    return variant.options.every((variantOption, index) => {
                        return (variant.available || this.isStickyAddToCart)
                        && (!this.optionIsChangeable[index] || String(variantOption) === String(testOptions[index]));
                    });
                });

                option.disabled = !exists;
            });
        });
    }

    getSelectedVariant() {
        const selectedOptions = this.getSelectedOptions();

        return this.variantsData.find((variant) => {
            return variant.options.every((option, index) => (!this.optionIsChangeable[index] || option === selectedOptions[index]));
        });
    }
}

window.addEventListener('product-recommendations:loaded', () => {
    document.querySelectorAll('product-recommendations').forEach((productRecommendations) => {
        productRecommendations.querySelectorAll('[data-aw-product-form]').forEach((container) => {
            new AWProductForm(container);
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-aw-product-form]').forEach((container) => {
        new AWProductForm(container);
    });

    const stickyAddToCart = document.querySelector('[data-sticky-add-to-cart]');
    if (!stickyAddToCart) return;

    const generalAddToCart = document.querySelector('form[data-type="add-to-cart-form"]');
    const stickyAddToCartForm = new AWProductForm(stickyAddToCart, true);

    if (generalAddToCart && stickyAddToCartForm.addToCartButton) {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.boundingClientRect.bottom <= 0) {
                stickyAddToCart.style.transform = 'translateY(0)';
            } else {
                stickyAddToCart.style.transform = 'translateY(100%)';
            }
        }, { threshold: 0 });

        observer.observe(generalAddToCart);
    }

    if (generalAddToCart && stickyAddToCartForm.addToCartButton) {
        const updateStickyAddToCart = () => {
            const rect = generalAddToCart.getBoundingClientRect();
            stickyAddToCart.style.transform = rect.bottom <= 0 ? 'translateY(0)' : 'translateY(100%)';
        };

        const observer = new IntersectionObserver(() => { updateStickyAddToCart(); }, { threshold: 0 });

        observer.observe(generalAddToCart);

        updateStickyAddToCart();

        window.addEventListener('load', updateStickyAddToCart);
        window.addEventListener('pageshow', updateStickyAddToCart);
    }

    const showOptionsButton = stickyAddToCart.querySelector('[data-sticky-show-options-button]');
    const stickyOptions = stickyAddToCart.querySelector('[data-sticky-options]');

    let isOptionsOpen = false;

    function isMobile() {
        return window.matchMedia('(max-width: 1023px)').matches;
    }

    function openOptions() {
        if (!isMobile() || !stickyOptions) return;

        isOptionsOpen = true;

        stickyOptions.classList.remove('tw:grid-rows-[0fr]');
        stickyOptions.classList.add('tw:grid-rows-[1fr]');

        showOptionsButton?.setAttribute('aria-expanded', 'true');
        showOptionsButton?.querySelector('svg')?.classList.add('tw:rotate-180');
    }

    function closeOptions() {
        if (!stickyOptions) return;

        isOptionsOpen = false;

        stickyOptions.classList.remove('tw:grid-rows-[1fr]');
        stickyOptions.classList.add('tw:grid-rows-[0fr]');

        showOptionsButton?.setAttribute('aria-expanded', 'false');
        showOptionsButton?.querySelector('svg')?.classList.remove('tw:rotate-180');
    }

    function toggleOptions() {
        if (!isMobile()) return;

        if (isOptionsOpen) {
            closeOptions();
        } else {
            openOptions();
        }
    }

    if (showOptionsButton && stickyOptions) {
        showOptionsButton.setAttribute('aria-expanded', 'false');
        showOptionsButton.classList.add('tw:transition-transform', 'tw:duration-300');

        showOptionsButton.addEventListener('click', toggleOptions);
    }
});